import { RiskLevel } from "@/model/RiskLevel";
import { DefaultLower, NullBanner } from "@/model/DefaultBanners";
import BarnsleyLogo from "@/assets/regions/alcohol-alliance-barnsley-logo.png";
import BarnsleyLogoHigh from "@/assets/regions/Barnsley-Service-logo-Square-Oct-2020.png";
const BarnsleyIncreasing = {
    rawCopy: `For Increasing Risk scores we recommend that you cut down your drinking. Click here to <u>book a free online appointment</u> with a DrinkCoach.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/13"
};
const BarnsleyHigher = {
    rawCopy: `For Higher Risk scores we recommend that you cut down your drinking. Click here to <u>book a free online appointment</u> with a DrinkCoach.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/13"
};
const BarnsleyHigh = {
    rawCopy: "For High Risk scores we recommend that you cut down your drinking. For advice and support call Barnsley Recovery Steps on 01226&nbsp;779066 or <u>find out more here</u>",
    logoLink: "https://www.humankindcharity.org.uk/service/barnsley-recovery-steps"
};
export default {
    name: "Barnsley",
    logo: {
        file: BarnsleyLogo,
        width: 479,
        height: 254
    },
    zoomLevel: 11,
    logoHigh: {
        file: BarnsleyLogoHigh,
        width: 260,
        height: 260
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: BarnsleyIncreasing,
        [RiskLevel.Higher]: BarnsleyHigher,
        [RiskLevel.High]: BarnsleyHigh
    },
    clinics: [
        {
            name: "Barnsley Recovery Steps",
            description: "hide",
            isPrimaryProvider: true,
            phone: ["01226 779066"],
            website: "https://www.humankindcharity.org.uk/service/barnsley-recovery-steps",
            email: "brs.referrals@humankindcharity.org.uk",
            linkToSupportFinder: true
        },
        {
            name: "DrinkCoach Online Appointment",
            tagline: "Free coaching sessions are available for adults aged 18+ in Barnsley. Daytime, evening and weekend appointments available.<a href='https://drinkcoach.bookinglive.com/book/add/p/11' target='_blank'>Click here</a> to book an appointment.",
            alwaysShowInResults: true,
            alwaysShowFirst: true,
            website: "https://drinkcoach.org.uk/book-online-appointment"
        },
        {
            name: "Barnsley Recovery Steps",
            showAtRiskLevel: [RiskLevel.Lower, RiskLevel.High, RiskLevel.Higher],
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    info: "<br>Due to COVID we are operating an appointment only service. Please contact us to make an appointment.",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            phone: ["01226 779066"],
            website: "https://www.humankindcharity.org.uk/service/barnsley-recovery-steps",
            address: "5-6 Burleigh Court, Burleigh St, Barnsley, S70 1XY",
            location: { lat: 53.5495245, lng: -1.4795909 }
        },
        {
            name: "Barnsley Recovery Steps",
            showAtRiskLevel: [RiskLevel.Lower, RiskLevel.High, RiskLevel.Higher],
            times: [
                {
                    title: "Opening times (appointment only):",
                    info: "<br>Due to COVID we are operating an appointment only service. Please contact us to make an appointment.",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            phone: ["01226 779066"],
            website: "https://www.humankindcharity.org.uk/service/barnsley-recovery-steps",
            address: "Dearne Enterprise Centre, 1 Barnburgh Ln, Goldthorpe, Rotherham, S63 9PG",
            location: { lat: 53.5306383, lng: -1.3057141 }
        },
        {
            name: "Barnsley Recovery Steps",
            showAtRiskLevel: [RiskLevel.Lower, RiskLevel.High, RiskLevel.Higher],
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            phone: ["01226 779066"],
            website: "https://www.humankindcharity.org.uk/service/barnsley-recovery-steps",
            address: "McLintocks Building, Crookes Street, Barnsley, S70 6BX",
            location: { lat: 53.5531794, lng: -1.4911452 }
        },
        {
            name: "Umbrella Early Intervention & Prevention Service",
            description: "Local service providing a range of support to improve emotional wellbeing of those experiencing low level depression or anxiety.",
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            phone: ["01226 704 090"],
            website: "https://www.humankindcharity.org.uk/service/umbrella-early-intervention-and-prevention-support-service",
            address: "McLintocks Building, Crookes Street, Barnsley, S70 6BX",
            location: { lat: 53.5531794, lng: -1.4911452 }
        },
        {
            name: "Young Peoples Substance Misuse Service",
            description: "The Young People's Substance Misuse Service provides help and support to young people - and their families - who might be going through a difficult time with drug and alcohol use. The service is available to anyone under the age of 18. Outreach and out of hours appointments available upon request.",
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            phone: ["01226 7059800"],
            website: "https://fsd.barnsley.gov.uk/kb5/barnsley/fisd/service.page?id=EKsLu81NxqU&familychannel=1793",
            address: "18 Regent Street, Barnsley, S70 2HG",
            location: { lat: 53.5546749, lng: -1.4820385 }
        },
        {
            name: "Alcoholics Anonymous",
            description: "Due to COVID all AA meetings have moved to online. To find out more and to register your interest in attending visit the website",
            website: "https://www.alcoholics-anonymous.org.uk/AA-Meetings/Online-_-Telephonic-Meetings",
            alwaysShowInResults: true
        },
        {
            name: "SMART Recovery",
            description: "All SMART Recovery meetings are currently online. Further information is available here:",
            website: "https://smartrecovery.org.uk/online-meetings/",
            alwaysShowInResults: true
        }
    ]
};
//# sourceMappingURL=Barnsley.js.map